import {
  isStrictDimention
} from '../../core/type-dimensions';

require('./query-builder-node.component.scss');

const conditionsMeta = {
  '=': {
    name: '=',
    label: gettext('Равно'),
    controlType: 'value',
  },
  '!': {
    name: '!',
    label: gettext('Не равно'),
    controlType: 'value',
  },
  '^': {
    name: '^',
    label: gettext('Содержит'),
    controlType: 'text',
  },
  '!^': {
    name: '!^',
    label: gettext('Не содержит'),
    controlType: 'text',
  },
};

export class QueryBuilderNodeController {

  constructor($scope, CurrentModelService, ErrorHandlerService) {
    this.$scope = $scope;
    this.ErrorHandlerService = ErrorHandlerService;
    this.CurrentModelService = CurrentModelService;

    this.operators = ['AND', 'OR'];
    this.operatorLabels = {
      'AND': gettext('И'),
      'OR': gettext('ИЛИ'),
    };
    this.conditionsMeta = conditionsMeta;
    this.dimension = this.dimensions[0];
    this.node = null;
    this.nodeValue = '';
  }

  $postLink() {
    if (this.isCondition) {
      this.dimension = this.dimensions.find(dimension =>
        dimension.name.startsWith(this.node.dimension));
      if (!this.dimension) {
        this.ErrorHandlerService.filterErrorMessage.text = gettext('Неправильный параметр') + ` "dimension" : "${this.node.dimension}" `;
        this.ErrorHandlerService.filterErrorMessage.sourse = 'query-builder';

      }
      this.updateConditions();
      this.$scope.$watch('$ctrl.node.condition', (newValue, oldValue) => {
        if (!newValue) return;
        try {
          const newType = this.conditionsMeta[newValue].controlType;
          const oldType = oldValue ? this.conditionsMeta[oldValue].controlType : null;
          if (newType !== oldType) {
            this.resetNodeValue();
          }
          this.nodeValue = this.node.value;
        } catch (err) { //
        }

      });
    }
  }

  get isQueryError() {
    return !!(this.ErrorHandlerService.filterErrorMessage && this.ErrorHandlerService.filterErrorMessage.text);
  }

  get isCondition() {
    return this.node && !this.node.hasOwnProperty('group');
  }

  get isGroup() {
    return !this.isCondition;
  }

  get dimensions() {
    return this.CurrentModelService.model ? this.CurrentModelService.model.dimensions : '';
  }

  addCondition() {
    // if (this.isQueryError) return;
    const dimension = this.dimensions[0];
    this.node.group.rules.push({
      condition: '=',
      dimension: dimension.name,
      hierarchy: dimension.getDefaultHierarchy().name,
      value: '',
    });
  }

  addGroup() {
    // if (this.isQueryError) return;
    this.node.group.rules.push(this.createGroup());
  }

  createGroup() {
    return {
      group: {
        operator: this.operators[0],
        rules: [],
      },
    };
  }

  remove() {
    if ('node' in this.$scope.$parent.$ctrl) {
      this.$scope.$parent.$ctrl.node.group.rules =
        this.$scope.$parent.$ctrl.node.group.rules.filter(r => r !== this.node);
    }
  }

  onDimensionChange() {
    this.node.dimension = this.dimension.name;
    this.node.hierarchy = this.dimension.getDefaultHierarchy().name;
    this.resetNodeValue();
    this.updateConditions();
  }

  resetNodeValue() {
    if (this.node.condition === '^' || this.node.condition === '!^') {
      this.node.value = this.nodeValue;
      this.node.label = this.nodeValue;
    } else {
      this.node.value = '';
      this.node.label = '';
    }
  }

  onHierarchyChange() {
    this.resetNodeValue();
    this.updateConditions();
  }

  onConditionChange() {}

  isSearchable1() {
    return false;
  }

  isSearchable() {
    if (isStrictDimention(this.node.dimension, this.node.hierarchy)) return false;
    try {
      const hierarchy = this.CurrentModelService.model.getHierarchy(
        this.node.dimension, this.node.hierarchy);
      return hierarchy.levels.some(level =>
        hierarchy.dimension.getLevel(level).attributes.some(attr => attr.search));
    } catch (err) {

      this.ErrorHandlerService.filterErrorMessage.text = gettext('Неправильные параметры') + ` "dimension" : "${this.node.dimension}" ` +
        gettext('или') + ` "hierarchy" : "${this.node.hierarchy}"`;
      this.ErrorHandlerService.filterErrorMessage.sourse = 'query-builder';

      return null;
    }
  }

  updateConditions() {
    if (this.isSearchable()) {
      this.conditions = [
        conditionsMeta['='], conditionsMeta['!'],
        conditionsMeta['^'], conditionsMeta['!^'],
      ];
    } else {
      this.conditions = [
        conditionsMeta['='], conditionsMeta['!'],
      ];
    }
    if (!this.node.condition) {
      const errMessage = gettext('"condition" обязателен');
      this.$scope.$emit('error', errMessage);
      return;
    }
    if (this.conditions.indexOf(conditionsMeta[this.node.condition]) === -1) {
      this.node.condition = this.conditions[0].name;
    }

  }

  onSelectValue(filter) {
    if (this.node.value) {
      this.node.value.push(filter);
    } else {
      this.node.value = [filter];
    }

  }
}

export const QueryBuilderNodeComponent = {
  bindings: {
    node: '<',
    isRoot: '<?',
  },
  template: require('./query-builder-node.component.html'),
  controller: QueryBuilderNodeController,
};



// WEBPACK FOOTER //
// ./src/filter/query-builder/query-builder-node.component.js